export const RowsPerPage = 30;

export const RowsPerPageOptions = [30, 50, 100];
